module.exports = __webpack_public_path__ + "static/media/icon-refresh.c41cf8bb.svg";